//@ts-ignore
import Twemoji from 'react-twemoji';
import emojis from './data/emojis';
import Tippy from '@tippyjs/react';
import { Message } from 'types';

export default function EmojiMarkdown({
    children,
    message
}: { children: any, message: Message }) {
    if (typeof children !== 'string') return null;
    let emoji = emojis.find((emoji) => emoji.emoji === children);
    if(!emoji && children.match(/<:([A-Za-z0-9_-]+):([A-Za-z0-9_-]+)>/g)){
        emoji = {
            id: children.split(':')[2].split('>')[0],
            aliases: [children.split(':')[1]],
        } as any;
    }
    const isSingleEmoji = message.content === children && message.content.length === children.length;
    const emojiClass = isSingleEmoji ? 'h-12 w-12' : 'h-5 w-5';

    return (
        <Tippy content={
            ":"+emoji?.aliases[0]+":"
        } placement="top" interactive={false}>
            <span className="inline-block align-middle mr-1">
                <Twemoji options={{ className: 'w-5' }}>
                    {emoji?.emoji && (
                        <span>{emoji?.emoji}</span>
                    ) || message?.emojis?.includes((emoji as any)?.id) && (
                        <>
                        <img src={(import.meta.env.VITE_BUCKET_URL + "emojis/" + (emoji as any)?.id + ".webp").replace("webp", "png")} draggable={false} className={emojiClass+ " group-hover:hidden"} />
                        <img src={import.meta.env.VITE_BUCKET_URL + "emojis/" + (emoji as any)?.id + ".webp"} draggable={false} className={emojiClass+ " group-hover:block hidden"} />
                        </>
                    ) || (
                        <span>{children}</span>
                    )}
                </Twemoji>
            </span>
        </Tippy>
    );
}